import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { IconBrandInstagram, IconBrandLinkedin } from "@tabler/icons-react";
import { Link as RouterLink } from "react-router-dom";
import footerLogo from "../../assets/images/logo/footerLogo.png";
import Text from "../ui/Text";

const StyledFooter = styled(Box)(({ theme }) => ({
  backgroundColor: "#000000",
  color: "#ffffff",
  padding: "32px 16px",
  [theme.breakpoints.up("lg")]: {
    padding: "48px 80px",
  },
}));

const SectionTitle = styled(Text)(({ theme }) => ({
  fontWeight: "700",
  fontSize: "16px",
  color: "white",
  letterSpacing: "0.5px",
  marginBottom: "24px",
  display: "block",
  [theme.breakpoints.up("md")]: {
    fontSize: "16px",
    marginBottom: "24px",
  },
}));

const FooterText = styled(Text)(({ theme }) => ({
  color: "white",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: "400",
  [theme.breakpoints.down("md")]: {
    fontSize: "14px",
  },
}));

const Footer = () => {
  return (
    <StyledFooter component="footer">
      <Container maxWidth="xl" sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "center" },
            // textAlign: { xs: "center", md: "left" },
            gap: { xs: 5, md: 6 },
          }}
        >
          <Box
            sx={{
              position: "relative",
              height: { xs: 44, md: 74 },
              width: "fit-content",
            }}
          >
            <img
              src={footerLogo}
              alt="Footer Logo"
              style={{ objectFit: "contain", height: "100%", width: "100%" }}
            />
          </Box>
          <Box sx={{ maxWidth: { md: "300px", xs: "100%" } }}>
            <FooterText>
              Our mission is to unite casual sports players and give you the
              tools to make running games hassle free.
            </FooterText>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              ml: { md: "auto" },
            }}
          >
            <Text sx={{ color: "white", fontSize: "18px", fontWeight: "700" }}>
              Join Us
            </Text>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Link
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="FindASide on Instagram"
                sx={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <IconBrandInstagram size={30} aria-hidden="true" />
              </Link>
              <Link
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="FindASide on LinkedIn"
                sx={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <IconBrandLinkedin size={30} aria-hidden="true" />
              </Link>
            </Box>
          </Box>
        </Box>

        <Divider sx={{ backgroundColor: "#C1C7CD", my: { xs: 5, md: 6 } }} />

        <Grid container spacing={4} justifyContent="space-between">
          <Grid size={{ xs: 12, md: 3 }}>
            <SectionTitle>For game hosts</SectionTitle>
            <List sx={{ p: 0 }}>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  component={RouterLink}
                  to="/about"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>About</FooterText>
                </Link>
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  href="https://slow-centipede-6ab.notion.site/How-payments-work-on-Findaside-2843273d40638042b99fd11353831436"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>How payments work</FooterText>
                </Link>
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  component={RouterLink}
                  to="/create-game"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>Create a game</FooterText>
                </Link>
              </ListItem>
            </List>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <SectionTitle>For players</SectionTitle>
            <List sx={{ p: 0 }}>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  href="#"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>Refund policy</FooterText>
                </Link>
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  href="https://slow-centipede-6ab.notion.site/Player-conduct-2843273d40638030b203da34c2cc1b7d"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>Player conduct</FooterText>
                </Link>
              </ListItem>
            </List>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <SectionTitle>Policies</SectionTitle>
            <List sx={{ p: 0 }}>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  href="https://slow-centipede-6ab.notion.site/Terms-and-Conditions-2843273d4063801d9ae2f13950d02c34"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>Terms & conditions</FooterText>
                </Link>
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Link
                  href="https://slow-centipede-6ab.notion.site/Privacy-Policy-2843273d40638050b960fcf0dbd1f122"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "white",
                    textDecoration: "none",
                    cursor: "pointer",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  <FooterText>Privacy policy</FooterText>
                </Link>
              </ListItem>
            </List>
          </Grid>

          <Grid size={{ xs: 12, md: 3 }}>
            <SectionTitle>Support</SectionTitle>
            <Box
              sx={{ display: "flex", flexDirection: { md: "column" }, gap: 1 }}
            >
              <FooterText>For help please contact</FooterText>
              <Link
                href="mailto:liam@findaside.app"
                sx={{
                  textDecoration: "underline",
                  color: "white",
                }}
              >
                <FooterText>liam@findaside.app</FooterText>
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ backgroundColor: "#C1C7CD", my: { xs: 5, md: 6 } }} />

        <Box
          sx={{
            display: { md: "flex" },
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
          }}
        >
          <Text
            sx={{
              color: "white",
              fontSize: "14px",
              fontWeight: "400",
              mr: { xs: 0, md: "auto" },
            }}
          >
            Findaside 2025. All rights reserved.
          </Text>
          <Link
            href="https://slow-centipede-6ab.notion.site/Terms-and-Conditions-2843273d4063801d9ae2f13950d02c34"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: { xs: "none", md: "block" },
              color: "white",
              textDecoration: "none",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            <FooterText>Terms and conditions</FooterText>
          </Link>
          <Link
            href="https://slow-centipede-6ab.notion.site/Privacy-Policy-2843273d40638050b960fcf0dbd1f122"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: { xs: "none", md: "block" },
              color: "white",
              textDecoration: "none",
              cursor: "pointer",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            <FooterText>Privacy policy</FooterText>
          </Link>
        </Box>
      </Container>
    </StyledFooter>
  );
};

export default Footer;
